import * as React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from 'routes/Routes';
import Item from './components/Item';
import Icon from 'modules/Icon';

interface BreadcrumbsProps {
  children?: React.ReactNode[] | React.ReactNode;
}

const Breadcrumbs = ({ children }: BreadcrumbsProps) => {
  return (
    <nav className="breadcrumb pd-0 mg-0 tx-12">
      <Link to={Routes.dashboard} className="breadcrumb-item">
        <Icon type="home" />
      </Link>
      {children}
    </nav>
  );
};

Breadcrumbs.Item = Item;

export default Breadcrumbs;
